import { render, staticRenderFns } from "./sfx-player.vue?vue&type=template&id=c3f091b8&scoped=true&"
import script from "./sfx-player.vue?vue&type=script&lang=js&"
export * from "./sfx-player.vue?vue&type=script&lang=js&"
import style0 from "./sfx-player.vue?vue&type=style&index=0&id=c3f091b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f091b8",
  null
  
)

export default component.exports